// Copyright (c) Docugami, Inc. All rights reserved.

import { TokenRange } from "networking/api";

export interface TokenKeyRange {
    fromTokenKey: string;
    toTokenKey: string;
}

export interface IMappedTokens {
    tokenRangeToTokenKeyRange: (tokenRange: TokenRange) => TokenKeyRange;
    tokenKeyRangeToTokenRange: (tokenKeyRange: TokenKeyRange) => TokenRange | undefined;
}

export type KeyToTokenMap = { [key: string]: MappedToken };
export type TokenToKeyMap = { [token: number]: MappedToken };

export interface MappedToken {
    token: number;
    key: string;
}

export function createDefaultMappedTokens(): IMappedTokens {
    const mappedTokens: IMappedTokens = {
        tokenRangeToTokenKeyRange: tokenRange => ({fromTokenKey: `k${tokenRange.fromTok}`, toTokenKey: `k${tokenRange.toTok}`}),
        tokenKeyRangeToTokenRange: keyRange => ({fromTok: keyRange.fromTokenKey === '0' ? 0 : Number.parseInt(keyRange.fromTokenKey.substring(1)), toTok: keyRange.toTokenKey === '0' ? 0 : Number.parseInt(keyRange.toTokenKey.substring(1))})
    };

    return mappedTokens;
}

export function createMappedTokens(keys: string[]): IMappedTokens {
    // Token keys are valid up to token index n + 1 since to tokens are exclusive
    const tokenKeys = [...keys]
    const keyToTokens: KeyToTokenMap = {};
    const mappedTokens: IMappedTokens = {
        tokenRangeToTokenKeyRange: tokenRange => ({ fromTokenKey: tokenKeys[tokenRange.fromTok], toTokenKey: tokenKeys[tokenRange.toTok] }),
        tokenKeyRangeToTokenRange: keyRange => tokenKeyRangeToTokenRange(keyRange, keyToTokens)
    };

    tokenKeys.forEach((value, index) => {
        const mappedToken: MappedToken = {
            token: index,
            key: value,
        }

        keyToTokens[mappedToken.key] = mappedToken;
    })

    return mappedTokens;
}

export const tokenRangeToTokenKeyRange = (tokenRange: TokenRange, map: TokenToKeyMap): TokenKeyRange => ({
    fromTokenKey: map[tokenRange.fromTok]!.key,
    toTokenKey: map[tokenRange.toTok]!.key
});

export const tokenKeyRangeToTokenRange = (tokenKeyRange: TokenKeyRange, map: KeyToTokenMap): TokenRange | undefined => {
    const fromToken = tokenKeyRange.fromTokenKey === "0" ? 0 : map[tokenKeyRange.fromTokenKey]?.token;
    const toToken = tokenKeyRange.toTokenKey === "0" ? 0 : map[tokenKeyRange.toTokenKey]?.token
    if (fromToken === undefined || toToken === undefined) {
        return;
    }

    return {
        fromTok: fromToken,
        toTok: toToken
    }
};
